import { Prefecture } from '@/domain/models/Store';
import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { StoreManagementStoreService } from '@/services/StoreManagement/AuthStores/StoreManagementStoreService';

export type StoreManagementAuthStore = {
  id: number;
  name: string;
  prefecture: Prefecture | '';
  city: string;
};

export const useStoreManagementAuthStoreList = async (): Promise<
  StoreManagementAuthStore[]
> => {
  const storeManagementStoreService = new StoreManagementStoreService(
    getClient()
  );
  try {
    return await storeManagementStoreService.list();
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
